var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Observer } from 'mobx-react-lite';
import React from "react";
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import './UIBlock.scss';
var UIBlock = function (props) {
    var children = props.children, propsToMakeObservable = __rest(props, ["children"]);
    var p = useProps(propsToMakeObservable);
    var s = useStore(function () { return ({
        get shouldShowHeader() {
            return p.title || p.headerContent || p.headerEndSlot;
        },
        get headerContent() {
            return typeof p.headerContent === 'function' ? React.createElement(p.headerContent, null) : p.headerContent;
        },
        get headerEndSlot() {
            return typeof p.headerEndSlot === 'function' ? React.createElement(p.headerEndSlot, null) : p.headerEndSlot;
        },
    }); });
    return React.createElement(Observer, { children: function () {
            var className = p.className, padded = p.padded, sticky = p.sticky, title = p.title, fullHeight = p.fullHeight, scrollable = p.scrollable, style = p.style, innerRef = p.innerRef, spaceChildren = p.spaceChildren;
            return React.createElement("div", { className: joinClassName('UIBlock', className, padded && 'padded', padded === 'all' && 'padded-all', sticky && 'sticky', sticky, fullHeight && 'fullHeight', scrollable && 'scrollable', spaceChildren && 'spaceChildren'), ref: innerRef, style: style, "data-vertical-layout-mode": p.verticalLayoutMode, "data-primary-color": p.primaryColorName, "data-cy": p.dataCy },
                s.shouldShowHeader && React.createElement("header", { className: "UIBlockHeader" },
                    React.createElement("div", { className: "UIBlockHeaderContent" },
                        title && React.createElement("h3", { className: "UIBlockTitle" }, title),
                        s.headerContent),
                    s.headerEndSlot && React.createElement("div", { className: "UIBlockHeaderEndSlot" }, s.headerEndSlot)),
                props.children);
        } });
};
export default UIBlock;
